// Dexie (IndexedDB) is no longer used — data lives on Supabase.
// This file only exports the UI constants used across the app.

import { CategoryIcon, BlockIcon } from '../ui/icons'

// `Icon` è il componente Lucide (vedi src/ui/icons.js per la mappa centrale).
// `color` / `bg` restano qui perché sono dati (usati anche da runtime CSS inline),
// non icone.
export const CATEGORIES = {
  lavoro:   { Icon: CategoryIcon.lavoro,   label: 'Lavoro',   color: '#4A90E2', bg: 'rgba(74,144,226,0.1)'  },
  casa:     { Icon: CategoryIcon.casa,     label: 'Casa',     color: '#27AE60', bg: 'rgba(39,174,96,0.1)'   },
  auto:     { Icon: CategoryIcon.auto,     label: 'Auto',     color: '#E74C3C', bg: 'rgba(231,76,60,0.1)'   },
  famiglia: { Icon: CategoryIcon.famiglia, label: 'Famiglia', color: '#9B59B6', bg: 'rgba(155,89,182,0.1)' },
  budget:   { Icon: CategoryIcon.budget,   label: 'Budget',   color: '#F39C12', bg: 'rgba(243,156,18,0.1)'  },
  altro:    { Icon: CategoryIcon.altro,    label: 'Altro',    color: '#6B7280', bg: 'rgba(107,114,128,0.1)' }
}

export const PRIORITIES = {
  alta:  { label: 'Alta',  color: '#E74C3C', bg: 'rgba(231,76,60,0.1)'  },
  media: { label: 'Media', color: '#F39C12', bg: 'rgba(243,156,18,0.1)' },
  bassa: { label: 'Bassa', color: '#27AE60', bg: 'rgba(39,174,96,0.1)'  }
}

// Blocchi / Indisponibilità — 4 tipi, colori neutri desaturati così stanno
// come "sfondo" nella vista calendario (pattern hatch diagonale).
// `stripe` = colore bordo/hatch lines. `fg` = testo/icona. `bg` = fill pastello.
export const BLOCK_TYPES = {
  Lavoro:  { Icon: BlockIcon.Lavoro,  label: 'Lavoro',  bg: '#E3E5EA', fg: '#4B5563', stripe: '#9CA3AF' },
  Viaggio: { Icon: BlockIcon.Viaggio, label: 'Viaggio', bg: '#DCE3EC', fg: '#3F5A7A', stripe: '#6B8AAE' },
  Focus:   { Icon: BlockIcon.Focus,   label: 'Focus',   bg: '#E3DEEC', fg: '#5B4B7A', stripe: '#8C7AB0' },
  Impegno: { Icon: BlockIcon.Impegno, label: 'Impegno', bg: '#DCE7DE', fg: '#3F6B52', stripe: '#6A9E7E' },
}
